"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.ContentStyled = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Popover = require("../../Popover.styles");

var ContentStyled = _styledComponents["default"].div.withConfig({
  displayName: "Contentstyles__ContentStyled",
  componentId: "sc-1abapfp-0"
})(["opacity:", ";position:fixed;transition:opacity ", " ease,visibility ", " ease;visibility:", ";z-index:", ";&:focus{outline:none;}"], function (props) {
  return props.isOpen ? 1 : 0;
}, _Popover.consts.transition, _Popover.consts.transition, function (props) {
  return props.isOpen ? "visible" : "hidden";
}, function (props) {
  return props.zIndex;
});

exports.ContentStyled = ContentStyled;
//# sourceMappingURL=Content.styles.js.map